import type { RegisterTranslations } from "../interfaces/register";

export const registerTranslations: RegisterTranslations = {
  register_button: "Registrarse",
  create_account_label_prefix: "¿No tienes una cuenta?",
  create_account_label_button: "Regístrate",
  or_label: "O",
  input_name_label: "Nombre",
  input_name_placeholder: "Ingrese su nombre",
  input_last_name_label: "Apellido",
  input_last_name_placeholder: "Ingrese su apellido",
  terms_and_conditions_text: "Al registrarte, aceptas nuestros términos y condiciones",

  page_title: "Crea tu cuenta",
  page_subtitle_persona: "Solo necesitamos tus datos personales para crear tu cuenta.",
  page_subtitle_empresa: "Registra tu información personal y la de tu organización en un solo paso.",

  account_type_label: "¿Cómo quieres registrarte?",
  account_type_persona_label: "Persona",
  account_type_persona_description: "Cuenta personal",
  account_type_empresa_label: "Empresa",
  account_type_empresa_description: "Registra tu organización",

  section_user: "Tus datos",
  section_user_heading: "Sobre ti",
  section_user_description: "Información que identifica tu cuenta personal.",
  section_organization: "Tu organización",
  section_organization_heading: "Espacio de trabajo",
  section_organization_description: "Información que identifica a tu organización.",

  terms_text_prefix: "Al continuar aceptas los ",
  terms_link: "Términos",
  terms_text_middle: " y la ",
  privacy_link: "Política de privacidad",
  terms_text_suffix: ".",

  user_name_label: "Nombre completo",
  user_name_placeholder: "Ingresa tu nombre completo",
  user_email_label: "Correo electrónico",
  user_email_placeholder: "tu@correo.com",
  user_password_label: "Contraseña",
  user_password_placeholder: "Mínimo 8 caracteres",
  user_country_label: "País",
  user_phone_label: "Teléfono",
  user_phone_placeholder: "Número con prefijo internacional",

  org_name_label: "Nombre de la organización",
  org_name_placeholder: "Ingresa el nombre de la organización",
  org_email_label: "Correo de contacto",
  org_phone_label: "Teléfono de contacto",
  org_country_label: "País",

  hint_mirror_email: "Igual que tu correo personal",
  hint_mirror_phone: "Igual que tu teléfono personal",
  hint_mirror_country: "Igual que tu país personal",
  hint_mirror_org_name: "Sugerido a partir de tu nombre",

  pwd_strength_empty: "Ingresa una contraseña",
  pwd_strength_weak: "Débil",
  pwd_strength_fair: "Aceptable",
  pwd_strength_good: "Buena",
  pwd_strength_strong: "Fuerte",
  pwd_strength_aria_label: "Indicador de fortaleza de la contraseña",

  submit_button: "Crear cuenta",
  submit_loading: "Creando cuenta...",

  error_required: "Campo obligatorio",
  error_email: "Correo inválido",
  error_name_length: "Debe tener entre 2 y 100 caracteres",
  error_org_name_length: "Debe tener entre 2 y 100 caracteres",
  error_password_min: "Mínimo 8 caracteres",
  error_password_number: "Debe incluir al menos un número",
  error_password_symbol: "Debe incluir al menos un símbolo",
  error_phone_format: "Formato de teléfono inválido (E.164)",
  error_country: "Selecciona un país",
  error_email_conflict: "El correo ya está registrado",
  error_generic: "Ocurrió un error. Intenta de nuevo.",

  verify_title: "Verifica tu correo",
  verify_subtitle: "Te enviamos un código de 6 dígitos para confirmar tu cuenta.",
  verify_sent_to_label: "Enviamos el código a",
  verify_new_code_sent_to_label: "Enviamos un código nuevo a",
  verify_code_label: "Código de verificación",
  verify_submit_button: "Verificar correo",
  verify_submitting: "Verificando...",
  verify_resend_button: "Reenviar código",
  verify_resend_cooldown: "Reenviar código ({{seconds}} s)",
  verify_resend_sent: "Te enviamos un nuevo código",
  verify_edit_email_link: "Cambiar",
  verify_edit_email_aria: "Cambiar el correo al que enviamos el código",
  verify_change_email_label: "Correo correcto",
  verify_change_email_hint: "Te enviaremos un código nuevo. Tus datos de registro se mantienen.",
  verify_change_email_submit: "Enviar código",
  verify_change_email_submitting: "Enviando...",
  verify_change_email_cancel: "Cancelar",
  verify_change_email_success: "Listo. Enviamos un código nuevo a {{email}}",
  verify_change_email_error_same: "Es el mismo correo al que enviamos el código.",
  verify_change_email_error_in_use: "Ya hay una cuenta con este correo. Inicia sesión con ella o usa otro.",
  verify_change_email_error_org_in_use: "Ya hay una organización con este correo. Usa otro.",
  verify_change_email_error_generic: "No pudimos cambiar el correo. Intenta de nuevo.",
  verify_sign_out_prompt: "¿Quieres entrar con otra cuenta?",
  verify_sign_out: "Cerrar sesión",
  verify_success_toast: "Correo verificado. ¡Bienvenido!",
  verify_error_invalid_code: "El código no es válido. Revísalo e intenta de nuevo.",
  verify_error_invalid_code_format: "El código debe tener 6 dígitos",
  verify_error_expired: "El código expiró. Solicita uno nuevo.",
  verify_error_already_verified: "Este correo ya está verificado.",
  verify_error_rate_limited: "Demasiados intentos. Espera unos segundos e intenta de nuevo.",
  verify_error_generic: "No pudimos verificar el código. Intenta de nuevo.",
};
